const e=8e6;export{e as FILE_MAX_SIZE};
